<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：订单信息
  -->
  <div class="pb50">
    <div class="product-content">
      <!--用户信息-->
      <div class="common-form">用户信息</div>
      <div class="table-wrap">
        <el-row v-if="detail.user">
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">用户ID：</span>
              {{ detail.user ? detail.user.userId : '' }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">用户昵称：</span>
              {{ detail.user ? detail.user.nickName : '暂无昵称' }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">电话：</span>
              {{ detail.user ? detail.user.mobile : '暂无电话' }}
            </div>
          </el-col>
        </el-row>
      </div>

      <!--客户信息-->
      <div v-if="detail.deliveryType && detail.deliveryType == 10">
        <div class="common-form mt16">客户信息</div>
        <div class="table-wrap">
          <el-row v-if="detail.address">
            <el-col>
              <div class="pb16">
                <span class="gray9">用户姓名：</span>
                {{ detail.address.name }}
              </div>
            </el-col>
            <el-col>
              <div class="pb16">
                <span class="gray9">联系电话：</span>
                {{ detail.address.phone }}
              </div>
            </el-col>
            <el-col>
              <!-- <div class="pb16" v-if="detail.address">
                <span class="gray9" v-if="detail.address.region">服务地址：</span>
                {{ detail.address.region.province }} {{ detail.address.region.city }} {{ detail.address.region.region }}
                {{ detail.address.detail }}
              </div> -->
              <!-- <div class="pb16" v-if="detail.delivery_status.value!=20">
								<el-button type="text" size="small" @click='changeAdd'> 修改地址</el-button>
							</div> -->
            </el-col>
            <el-col>
              <div class="pb16">
                <span class="gray9">预约时间：</span>
                {{ changetime(detail.anticipateTime)||'-' }}
              </div>
            </el-col>
            <el-col>
              <div class="pb16">
                <span class="gray9">备注：</span>
                {{ detail.buyerRemark||'--' }}
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!--商户信息-->
      <div class="common-form mt16">商家信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">商家名称：{{ detail.supplier ? detail.supplier.name : '--' }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">联系方式：{{ detail.supplier ? detail.supplier.linkPhone : '--' }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--城市站点信息-->
      <!-- <div class="common-form mt16">城市站点信息</div>
			<div class="table-wrap">
				<el-row>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9" v-if="detail.supplier">站点：{{ detail.supplier.name }}</span>
						</div>
					</el-col>
					<el-col :span="8">
						<div class="pb16">
							<span class="gray9">联系方式：</span>
						</div>
					</el-col>
				</el-row>
			</div> -->
      <!-- 订单信息 -->
      <div class="common-form">订单信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">创建时间：</span>
              {{ detail.createTime }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">支付金额：</span>
              {{ detail.orderPrice }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">支付总价：</span>
              {{ detail.payPrice }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">优惠金额：</span>
              {{ detail.vipPrice }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16" v-if="detail.fare_param_json">
              <span class="gray9" >技师车费：</span>
              {{ detail.fare_param_json.price||0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16" v-if="detail.fare_param_json">
              <span class="gray9">全程距离：</span>
              {{ detail.fare_param_json.distance||0 }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16" v-if="detail.fare_param_json">
              <span class="gray9" >出行方式：</span>
              {{ detail.fare_param_json.name  }}
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="common-form">技师信息</div>
      <div class="table-wrap" v-if="detail.waiter">
        <el-row>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">技师名称：</span>
              {{ detail.waiter.nickname }}
            </div>
          </el-col>
         
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">手机号：</span>
              {{ detail.waiter.mobile }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">已完成单量：</span>
              {{ detail.waiter.orderNum }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">评论量：</span>
              {{ detail.waiter.commentNum }}
            </div>
          </el-col>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">当前车费：</span>
              {{ detail.waiter.farePrice }}
            </div>
          </el-col>
          
         

        </el-row>
      </div>
      <!--买家留言-->
      <div class="common-form mt16">用户留言</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="8">
            <div class="pb16">
              <span class="gray9">留言:</span>
              {{ detail.buyerRemark }}
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- <changeAddress :isChange="isChange" :addressData="addressData" @closeDialog='closeAddress'></changeAddress> -->
    <!-- 修改技师子组件 -->
    <!-- <modify :isModify="isModify" ref="modify" @closeDialog='close($event)'></modify> -->
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import changeAddress from "@/components/order/changeAddress.vue";
import { formatDate } from "@/utils/DateTime.js";
import { deepClone } from "@/utils/base.js";
export default {
   inject: ["detail"],
  components: {
    changeAddress
  },
  data() {
    return {
      // 技师是否显示
      isModify: false,
      /*是否加载完成*/
      loading: true,
      /*是否打开添加弹窗*/
      open_add: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      extract_form: {
        order: {
          extract_status: 1
        }
      },
      order: {},
      delivery_type: 0,
      isChange: false,
      addressData: {
        name: "",
        phone: "",
        province_id: 0,
        city: "",
        city_id: 0,
        region: "",
        region_id: 0,
        region: {
          province: "",
          province_id: 0,
          city: "",
          city_id: 0,
          region: "",
          region_id: 0,
          detail: "",
          username: ""
        }
      },
      uses: "",
      user_id: "",
      fare_param_json:{}
    };
  },
  created(e) {
    /*获取列表*/
    console.log(this.detail,9090123)
    console.log(this.detail.user,9090123)
    // if(this.detail.fareParam){
    // this.fare_param_json=JSON.parse(this.detail.fareParam)

    // }
    // this.getParams();
  },
  methods: {
    modifys() {
      this.$router.push({
        path: "/order/order/some",
        query: {
          orderId: this.$route.query.orderId,
          user_id: this.detail.waiter_user_id
        }
      });
    },
    changetTime(e) {
      return e
    },
    next() {
      if (this.active++ > 4) this.active = 0;
    },
    
    changetime(e) {
      var date = new Date(e * 1000); // 将秒数转换为毫秒
      var year = date.getFullYear();
      var month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始，需要加1
      var day = date.getDate().toString().padStart(2, '0');
       
    let h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    let m = date.getMinutes();
    m = m < 10 ? ('0' + m) : m;
    let s = date.getSeconds();
    s = s < 10 ? ('0' + s) : s;
    return `${year}-${month}-${day}`+ ' ' + h + ':' + m + ':' + s;
     
    },
    /*获取参数*/
    // getParams() {
    //   let self = this;
    //   // 取到路由带过来的参数
    //   const params = this.$route.query.orderId;
    //   OrderApi.orderdetail(
    //     {
    //       orderId: params
    //     },
    //     true
    //   )
    //     .then(data => {
    //       self.loading = false;
    //       self.detail = data.data.detail;
    //       self.addressData = self.detail.address;
    //       // self.username = self.detail.username
    //       self.user_id = self.detail.waiter_user_id;
    //       self.uses = self.detail.username;
    //     })
    //     .catch(error => {
    //       self.loading = false;
    //     });
    // },

    changeAdd() {
      this.isChange = true;
    },
    closeAddress(e) {
      let self = this;
      if (e == false) {
        self.isChange = false;
        console.log(e);
        return false;
      }
      let params = e.params;
      console.log(params);
      params.orderId = self.$route.query.orderId;
      OrderApi.updateAddress(params, true)
        .then(data => {
          self.$message({
            message: "修改成功",
            type: "success"
          });
        })
        .catch(error => { });
      self.isChange = false;
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/part/order.vue